import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon } from '@mantine/core';

type FavoriteToggleButtonType = {
  onClick: () => void;
  isFavorised: boolean;
};

export const FavoriteToggleButton: React.FC<FavoriteToggleButtonType> = ({
  onClick,
  isFavorised,
}) => {
  return (
    <ActionIcon
      color="blue"
      variant={!isFavorised ? 'outline' : 'filled'}
      onClick={onClick}
      data-testid="favorite-toggle-button"
    >
      <FontAwesomeIcon icon={faStar} size="lg" />
    </ActionIcon>
  );
};
